import React from 'react';

export const BillingInfoContext = React.createContext({});
